import { FC, memo } from 'react';
import { ReportSummaryFilterForm, IReportSummaryFilterForm } from './ReportSummaryFilterForm';

export const ReportSummaryFilter: FC<IReportSummaryFilterForm> = memo((props) => (
  <ReportSummaryFilterForm {...props} />
));
